<template>
  <div v-if="loginUser.delFlag == -1">
    <a-result status="403" title="Sorry" sub-title="非正式员工不能操作此页面">
      <template #extra> </template>
    </a-result>
  </div>
  <a-spin :spinning="loading" v-else>
    <a-row :gutter="[12, 12]" class="a-row-center">
      <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12" :xxl="10">
        <a-row :gutter="[12, 12]" style="background: transparent; display: flex; flex-wrap: wrap">
          <a-col :xs="24" style="width: 50%"> </a-col>

          <a-col :xs="24" style="width: 50%"> </a-col>
        </a-row>

        <a-row :gutter="[0, 0]" style="background: transparent">
          <a-col :xs="24" :sm="24" style="padding-top: 12px"> </a-col>
        </a-row>
      </a-col>

      <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12" :xxl="14"> </a-col>
    </a-row>

    <j-modal
      title=""
      :footer="null"
      :width="390"
      :visible="showBirthday"
      @cancel="showBirthday = false"
      dialogClass="BirthdayWrapper"
    >
      <img src="/生日祝福图片.jpg" />
    </j-modal>

    <j-modal
      title="档案借阅归还提醒"
      size="normal"
      :visible="archVisible"
      @ok="archVisible = false"
      @cancel="archVisible = false"
    >
      <div slot="footer">
        <a-button @click="archVisible = false" type="primary" icon="close">关闭</a-button>
      </div>
    </j-modal>
  </a-spin>
</template>

<script>
import { tableMixin } from '@/mixins/tableMixin'
import { mixin, mixinDevice } from '@/utils/mixin.js'
import { deleteAction, getAction } from '@/api/manage'

export default {
  name: 'Portal',
  mixins: [tableMixin, mixin, mixinDevice],
  components: {},
  data() {
    return {
      // ユーザID
      loginUser: this.$getLoginUser(),
      archVisible: false,
      showBirthday: false,
      loaded: false,
      repDicts: [],
      url: {
        warn: '/ArchBorrowApply/warn',
      },
    }
  },
  activated() {
    this.loaded = false
    this.repDicts = []
    this.init()
  },
  created() {
    // 画面初期化
    this.init()
  },
  mounted() {
    // モバイルの場合、リサイズする
    resizeForMobile()

    // 显示生日祝福
    if (
      this.$getLoginUser().birthday &&
      moment(this.$getLoginUser().birthday).format('MM-DD') == moment().format('MM-DD')
    ) {
      // 如果已显示过则不再显示
      if (localStorage['showBirthday'] && localStorage['showBirthday'] == moment().format('YYYY-MM-DD')) {
        return
      }

      this.showBirthday = true
      localStorage['showBirthday'] = moment().format('YYYY-MM-DD')
    }

    lottie
      .loadAnimation({
        container: document.querySelector('.graphic-content'),
        renderer: 'svg',
        loop: true,
        autoplay: false,
        path: `//${window.location.host}/svg/lottiefiles/repository-empty.json`,
      })
      .play()
  },
  watch: {},
  methods: {
    init() {
      //getAction('/kgms/demo/helloBigWorld', {}).then(res => {
      //    if (res.success) {
      //      console.log(res.message)
      //    }
      //  })
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .ant-card {
  border-radius: var(--border-radius);
}

/deep/ .a-row-center {
  background: transparent;
  //display: flex;
  //flex-wrap: wrap;
  //justify-content: center;
}

.graphic-content {
  /deep/ svg {
    path[fill='rgb(60,133,252)'],
    path[fill='rgb(94,155,255)'] {
      // 左文件夹
      fill: var(--color-primary-4);
    }

    path[fill='rgb(255,180,79)'],
    path[fill='rgb(255,184,89)'] {
      // 右文件夹
      fill: var(--color-primary3-4);
    }

    path[d^=' M46.215999603271484'] {
      // 左右外球
      fill: var(--color-primary-3);
    }

    path[d^=' M20.46500015258789'] {
      // 顶层小球
      fill: var(--color-primary-5);
    }

    path[fill='rgb(154,232,255)'] {
      // 边缘背景
      fill: var(--color-primary-2);
    }

    path[d^=' M-305.1210021972656'] {
      // 中心背景
      fill: var(--color-primary-4);
    }
  }
}

.portal-rep-grid {
  //width: calc(33.33333333% - 19px);
  //width: calc(33% - 14px);
  //max-width: 500px;
  //min-width: 300px;
  width: calc(100% - 55px);
  padding-bottom: 23px;
  padding-right: 55px;
  visibility: hidden;

  &.loaded {
    visibility: visible;
  }

  .mark {
    display: inline-block;
    width: 4px;
    height: 12px;
    border-radius: 10px;
    margin-right: 10px;
    vertical-align: middle;
    position: relative;
    top: -1px;
  }

  .title {
    font-size: 15px;
    color: black;
    border-bottom: 3px solid #f8f8f8;
    padding-bottom: 4px;
    margin-bottom: 10px;
    font-weight: 700;
  }

  .more {
    color: var(--color-grey);
    font-size: 12px;
    float: right;
    position: relative;
    top: 5px;
    right: 5px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      color: var(--color-primary);
    }
  }
}

@media (min-width: 1300px) {
  .portal-rep-grid {
    width: calc(50% - 26px);
  }
}

@media (min-width: 1600px) {
  .portal-rep-grid {
    width: calc(33% - 14px);
  }
}
</style>

<style lang="less">
.BirthdayWrapper .ant-modal-body {
  padding: 0;
  overflow-y: auto;
  max-height: calc(100vh - 12px);

  img {
    width: 100%;
    border-radius: 6px;
  }
}
</style>
